import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {Form, Select, message, DatePicker, Row, Col, Input, Button, Radio, Checkbox} from 'antd';
import {DmsTab, TableView, FilterBox} from 'Components';
import {detail, submit} from '../../service/survey';
import './survey.css';

const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;

class SurveyDetail extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['问卷详情'],
            detailData: {
                research: {},
                question: []
            },
            // TextArea里面的内容 this.state.detailData.research.description
            description: '',
            button_limits_end: {},
            anwers: []
        };
        this.radioGroupChange = this.radioGroupChange.bind(this);
        this.checkboxGroupChange = this.checkboxGroupChange.bind(this);
        this.textAreaChange = this.textAreaChange.bind(this);
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getData();
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
        });
    }

    getData = () => {
        detail({businessId: this.props.params.surveyId}).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    detailData: result.data,
                    description: result.data.research.description
                });
            } else {
                message.error(result.message);
            }
        });
    }

    save = () => {
        submit(this.state.anwers);
        this.goView(`/survey`);
    }

    //页面跳转
    goView = (url) => {
        hashHistory.push(url);
    }

    radioGroupChange = (e, type) => {
        var arrs = this.state.anwers || [];
        var i = 0;
        arrs.map((arr, index) => {
            if (arr.questionId == e.target.name) {
                arrs[index].answer = e.target.value;
                arrs[index].type = type;
                i++;
            }
        });
        if (i == 0) {
            arrs.push({questionId: e.target.name, answer: e.target.value, type: type});
        }
        this.setState({anwers: arrs});
    }
    checkboxGroupChange = (e, name, type) => {
        var arrs = this.state.anwers || [];
        var i = 0;
        arrs.map((arr, index) => {
            if (arr.questionId == name) {
                arrs[index].answer = e.join(",");
                arrs[index].type = type;
                i++;
            }
        });
        if (i == 0) {
            arrs.push({questionId: name, answer: e.join(","), type: type});
        }
        this.setState({anwers: arrs});
    }

    textAreaChange = (e, name, type) => {
        var arrs = this.state.anwers || [];
        var i = 0;
        arrs.map((arr, index) => {
            if (arr.questionId == name) {
                arrs[index].answer = e.target.value
                arrs[index].type = type;
                i++;
            }
        });
        if (i == 0) {
            arrs.push({questionId: name, answer: e.target.value, type: type});
        }
        this.setState({anwers: arrs});
    }

    render() {
        var self = this;
        const {opts, description, button_limits_end} = this.state;

        var problemHtmlRender = self.state.detailData.question.map((qst, key) => {
            if (qst.type == 0) {
                var options = [];
                (qst.answer || []).map(function (q, k) {
                    options.push({label: q.sortOrder + q.optionName, value: q.sortOrder});
                })
                return (
                    <li key={key}>
                        <p>{qst.sortOrder + '. ' + qst.questionName}</p>
                        <div><RadioGroup name={qst.id} options={options}
                                         onChange={(value) => {
                                             this.radioGroupChange(value, qst.type)
                                         }}></RadioGroup>
                        </div>
                    </li>
                )
            } else if (qst.type == 1) {
                var options = [];
                (qst.answer || []).map(function (q, k) {
                    options.push({label: q.sortOrder + q.optionName, value: q.sortOrder});
                })
                return (
                    <li key={key}>
                        <p>{qst.sortOrder + '. ' + qst.questionName}</p>
                        <div>
                            <CheckboxGroup name={qst.id} options={options}
                                           onChange={(value) => {
                                               this.checkboxGroupChange(value, qst.id, qst.type)
                                           }}></CheckboxGroup>
                        </div>
                    </li>
                )
            } else {
                return (
                    <li key={key}>
                        <p>{qst.sortOrder + '. ' + qst.questionName}</p>
                        <div>
                            <Input.TextArea onChange={(value) => {
                                this.textAreaChange(value, qst.id, qst.type)
                            }}></Input.TextArea>
                        </div>
                    </li>
                )
            }
        });

        return (
            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        {button_limits_end.survey_detail_01 && <Button
                            onClick={this.goView.bind(this, '/survey/' + this.props.params.surveyId + '/result')}>查看调研结果</Button>}
                        <Button onClick={this.save.bind(this)}>提交</Button>
                    </DmsTab>
                </div>

                <div className="dms-table-box">
                    <div className="survey_de">
                        <p>{this.state.detailData.research.title}</p>
                        <Input.TextArea readOnly placeholder={description}></Input.TextArea>
                        <Form onSubmit={this.save.bind(this)}>
                            {problemHtmlRender}
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(SurveyDetail);




// WEBPACK FOOTER //
// ./src/routes/survey/detail.js